module.exports = __webpack_public_path__ + "img/07.c634994d.png";